import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, TextField, Typography, useTheme } from "@mui/material";
import ContactInfoBox from "../SuportPage/ContactInfo";
import phoneRing from "../../../../media/images/icons/phoneRing.svg";
import SearchIcon from "../../../../media/images/icons/search";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import CompanyInfoBox from "./CompanyInfoBox";

export default function CommunicateCompanies() {
  const [hasScroll, setHasScroll] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            ارتباط با شرکت‌ها{" "}
          </Typography>
        }
        hasScroll={hasScroll}
      />
      <Box
        sx={{
          flex: 1,
          paddingX: "8px",
          overflow: "auto",
        }}
      >
        <ContactInfoBox />
        <Box
          sx={{
            mt: 2,
            paddingX: "16px",
            borderRadius: "16px",
            backgroundColor: "background.default",
          }}
        >
          <Box
            sx={{
              paddingY: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={phoneRing} alt="" />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              اطلاعات تماس و ارتباط با شرکت‌ها
            </Typography>
          </Box>
          <Typography>
            شما می‌توانید با جستجو نام شرکت ، اطلاعات تماس با شرکت مدنظر خود را
            پیدا کنید.
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid gray",
              paddingX: "8px",
              borderRadius: "16px",
              paddingY: "4px",
            }}
          >
            <TextField
              placeholder="نام شرکت را جستجو کنید"
              size="small"
              sx={{
                flex: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-input": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  outline: "none !important",
                },
                border: "none",
              }}
            />
            <SearchIcon color={theme.palette.primary.main} />
          </Box>
        </Box>
        <CompanyInfoBox />
        <CompanyInfoBox />
        <CompanyInfoBox />
      </Box>
      <BottomTabbar />
    </>
  );
}
